import React, { Component } from 'react';
import { connect } from "react-redux";
import moment from 'moment';
import FormTemplate from "../common/form/FormTemplate";
import { reportUser, exportUser, setSelectedReportType, ReportUserAuditKey } from "../../redux/actions/reportActions";
import { setSelectedControlPanelType, AuditLogReportControlPanelKey  } from "../../redux/actions/controlPanelActions";
import { amPmOptions, hourOptions, minuteOptions, validateDateTimes, validateYearRangeLimit } from "../../utils/DateValidation";
import { LOADING_STATUES } from "../../components/constants/constants";
import UserSelectionList   from "../common/selection/UserSelectionList";

const componentName = AuditLogReportControlPanelKey;

const matchDispatchToProps = (dispatch) => {
  return {
    setSelectedReportType: () => dispatch(setSelectedReportType(componentName)),
    reportUser: (searchCriteria, history, callback) => dispatch(reportUser(searchCriteria, history, callback)),
    exportUser: (searchCriteria, history, callback) => dispatch(exportUser(searchCriteria, history, callback)),
    setSelectedControlPanelType: () => dispatch(setSelectedControlPanelType(componentName))
  }
}

const mapStateToProps = (state) => {
  let reportByCriteria = state.reportCriteriaReducer[ReportUserAuditKey]; // Should be AuditLogReportControlPanelKey??? It doesn't work with AuditLogReportControlPanelKey.

  let fromDate = reportByCriteria['fromDate'] ? reportByCriteria['fromDate'] : moment().format('L');
  let toDate = reportByCriteria['toDate'] ? reportByCriteria['toDate'] : moment().format('L');
  let fromHour = reportByCriteria['fromHour'] ? reportByCriteria['fromHour'] : '12';
  let fromMinute = reportByCriteria['fromMinute'] ? reportByCriteria['fromMinute'] : '0';
  let fromAmPm = reportByCriteria['fromAmPm'] ? reportByCriteria['fromAmPm'] : 'am';
  let toHour = reportByCriteria['toHour'] ? reportByCriteria['toHour'] : '11';
  let toMinute = reportByCriteria['toMinute'] ? reportByCriteria['toMinute'] : '59';
  let toAmPm = reportByCriteria['toAmPm'] ? reportByCriteria['toAmPm'] : 'pm';

  let username = reportByCriteria['username'] ? reportByCriteria['username'] : '';


  return {
    fromDate,
    fromHour,
    fromMinute,
    fromAmPm,
    toDate,
    toHour,
    toMinute,
    toAmPm,
    username,
    role: state.currentUserReducer.role
  };
}

class UserReport extends Component {

  state = {
    fromDate: this.props.fromDate,
    toDate: this.props.toDate,
    fromHour: this.props.fromHour,
    fromMinute: this.props.fromMinute,
    fromAmPm: this.props.fromAmPm,
    toHour: this.props.toHour,
    toMinute: this.props.toMinute,
    toAmPm: this.props.toAmPm,
    username: this.props.username,
    showUserList: false,

    loadingStatus: "",
    errors: {}
  }

  handleSubmit = (event) => {
    event.preventDefault();
    if (this.handleValidation()) {
      if (this.showLoading() === true) {
        const { loadingStatus, errors, ...request } = this.state; // remove UI only fields before submitting
        this.props.reportUser(request, this.props.history, this.hideLoading);
      }
    }
  }

  handleExport = (event) => {
    event.preventDefault();
    if (this.handleValidation()) {
      if (this.showLoading() === true) {
        this.props.exportUser(this.state, this.props.history, this.hideLoading);
      }
    }
  }
  
  handleValidation() {
    let errors = {};
    if (!this.state.fromDate) {
      errors['fromDate'] = "Required.";
      this.setState({ errors: errors });
      return false;
    }

    let formIsValid = validateDateTimes(errors, this.state.fromDate, this.state.fromHour, this.state.fromMinute, this.state.fromAmPm, 'fromDate', this.state.toDate, this.state.toHour, this.state.toMinute, this.state.toAmPm, 'toDate');
    if (!formIsValid) {
      this.setState({ errors: errors });
      return false;
    }
    
    formIsValid = validateYearRangeLimit(errors, this.state.fromDate, 'fromDate', this.state.toDate, 'toDate');
    if (!formIsValid) {
      this.setState({ errors: errors });
      return false;
    }

    this.setState({ errors: errors });
    return true;
  }

  handleChange = (event) => {
    event.preventDefault();
    this.setState({
      [event.target.id]: event.target.value
    })
  }

  handleDatePickerChangeFromDate = (date) => {
    this.setState({
      fromDate : moment(date).format('L')
    })
  }

  handleDatePickerChangeToDate = (date) => {
    this.setState({
      toDate : moment(date).format('L')
    })
  }

  showLoading = () => {
    if (this.state.loadingStatus === "") {
      this.setState({
        loadingStatus: LOADING_STATUES.LOADING
      })
      return true;
    } 
    return false;
  }

  hideLoading = (message, status) => {
    if (status === 'ERROR') {
      alert(message);
    }
    this.setState({
      loadingStatus: ""
    })
  }
  
  handleUserLookup = () => {
    this.setState( {
      showUserList : true
    });
  }

  handleCloseUserLookup = (selectedId, selectedName) => {
    this.setState({
      showUserList: false,
      userId: selectedId,
      username: selectedName
    })
  }

  componentDidMount() {
    this.props.setSelectedControlPanelType();
    this.props.setSelectedReportType();
  }

  render() {
    
    let formGroupRows = [
      {
        formGroups: [{ id: 'fromDate', label: 'From Date', fieldType: 'date', value: this.state.fromDate, handleDatePickerChange: this.handleDatePickerChangeFromDate, error: this.state.errors['fromDate'] },
        { id: 'fromHour', label: '', fieldType: 'select', options: hourOptions, value: this.state.fromHour },
        { id: 'fromMinute', label: '', fieldType: 'select', options: minuteOptions, value: this.state.fromMinute },
        { id: 'fromAmPm', label: '', fieldType: 'select', options: amPmOptions, value: this.state.fromAmPm }]
      },
      {
        formGroups: [{ id: 'toDate', label: 'To Date', fieldType: 'date', value: this.state.toDate, handleDatePickerChange: this.handleDatePickerChangeToDate, error: this.state.errors['toDate'] },
        { id: 'toHour', label: '', fieldType: 'select', options: hourOptions, value: this.state.toHour },
        { id: 'toMinute', label: '', fieldType: 'select', options: minuteOptions, value: this.state.toMinute },
        { id: 'toAmPm', label: '', fieldType: 'select', options: amPmOptions, value: this.state.toAmPm }]
      }]
      
    formGroupRows.push({
        formGroups: [{ id: 'username', label: 'Username', fieldType: 'text', value: this.state.username },
        { id: 'userLookupButton', fieldType: 'lookup', onClick: this.handleUserLookup }]
    });

    const formProps = {
      componentName: componentName,
      pageHeading: "Audit Report - User",
      onChange: this.handleChange,
      onSubmit: this.handleSubmit,
      onSeconaryClick: this.handleExport,
      primaryButtonLabel: "PDF",
      secondaryButtonLabel: "Excel",
      successIndicator: this.state.loadingStatus === LOADING_STATUES.SUCCESS,
      loadingIndicator: this.state.loadingStatus === LOADING_STATUES.LOADING,
      formGroupRows: formGroupRows
    }

    return <>
    <FormTemplate {...formProps} />
     <UserSelectionList  showModal={this.state.showUserList} codeDescriptionResults={this.props.users} onHide={(selectedId, selectedName) => this.handleCloseUserLookup(selectedId, selectedName)} />  
    </>
  }
}

export default connect(mapStateToProps, matchDispatchToProps)(UserReport);